var app = angular.module('tf.photoUpload', [])

    .controller('photoUploadCtrl',
        ['$scope', '$uibModalInstance', '$window', 'userConfig', 'FileUploader', '$http', "currentUserService",
            function photoUploadController($scope, $uibModalInstance, $window, userConfig, FileUploader, $http, currentUserService) {

        $scope.croppedImage = '';

        $scope.showFileSelection = function () {
            angular.element('#fileDialog1').trigger('click');
        };

        var uploader = $scope.uploader = new FileUploader({
            url: '/tradefloor/api/image',
            method : 'POST',
            alias : 'file',
            queueLimit : 1
        });

        // FILTERS

        uploader.filters.push({
            name: 'imageFilter',
            fn: function(item /*{File|FileLikeObject}*/, options) {
                var type = '|' + item.type.slice(item.type.lastIndexOf('/') + 1) + '|';
                return '|jpg|png|jpeg|bmp|gif|'.indexOf(type) !== -1;
            }
        });

        // CALLBACKS

        /**
         * Show preview with cropping
         */
        uploader.onAfterAddingFile = function(item) {
            $scope.croppedImage = '';
            var reader = new FileReader();
            reader.onload = function(event) {
                $scope.$apply(function(){
                    $scope.image = event.target.result;
                });
            };
            reader.readAsDataURL(item._file);
        };

        /**
         * Upload Blob (cropped image) instead of file.
         * @see
         *   https://developer.mozilla.org/en-US/docs/Web/API/FormData
         *   https://github.com/nervgh/angular-file-upload/issues/208
         */
        uploader.onBeforeUploadItem = function(item) {
            var blob = dataURItoBlob($scope.croppedImage);
            item._file = blob;
        };

        /**
         * Converts data uri to Blob. Necessary for uploading.
         * @see
         *   http://stackoverflow.com/questions/4998908/convert-data-uri-to-file-then-append-to-formdata
         * @param  {String} dataURI
         * @return {Blob}
         */
        var dataURItoBlob = function(dataURI) {
            var binary = atob(dataURI.split(',')[1]);
            var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
            var array = [];
            for(var i = 0; i < binary.length; i++) {
                array.push(binary.charCodeAt(i));
            }
            return new Blob([new Uint8Array(array)], {type: mimeString});
        };

        uploader.onCompleteItem = function(fileItem, response, status, headers) {
            const url = headers.location;
            currentUserService.updateUserImage(url);

            $http.post('/tradefloor/api/user/image', url).then(function(response) {
                $uibModalInstance.close();
            });
        };

        $scope.setDefaultImage = function() {
            $http.post('/tradefloor/api/user/image', null).then(function(response) {
                const url = response.headers('location');
                currentUserService.updateUserImage(url);
                $uibModalInstance.dismiss();
            });
        };
    }]);



